<template>
    <div>
        <header class="viewHeader">
            <div class="header-top">
                <div class="header-left">
                    <div class="header-left-title">
                        <p>主体信息变更管理</p>
                        <span @click="goChangeList">查看历史变更记录</span>
                    </div>
                    <div class="header-left-name">
                        <p>{{informationData.mainName}}</p>
                    </div>
                </div>
                <div class="header-right">
                    <div class="header-right-icon" style="display: flex;align-items: center;margin: 0 37px 0 0">
<!--                        <img src="../../../assets/img/check-ok.png" alt="">-->
<!--                        <img src="../../../assets/img/check-no.png" alt="">-->
                    </div>
                    <div class="header-right-btn">
                        <span class="header-right-status">主体变更状态</span>
                        <span v-if="informationData.state == -1" style="color: orange;" class="header-right-examine">变更待提交</span>
                        <span v-if="informationData.state == 1" style="color: green;" class="header-right-examine">变更核验通过</span>
                        <span v-if="informationData.state == 6" style="color: orange;" class="header-right-examine">变更核验中</span>
                        <span v-if="informationData.state == 7" style="color: orangered;" class="header-right-examine">变更核验不通过</span>
                        <el-button class="header-right-more" @click="goChangeList">查看变更内容</el-button>
                    </div>
                </div>
            </div>
            <nav class="nav-list">
                <el-badge :is-dot="moduleList.includes('baseInfo')"><p :class="commonListActive == 0 ? 'active' : null" @click="tabToggle(0)">1 主体基本信息</p></el-badge>
                <el-badge :is-dot="moduleList.includes('qualificationCert')"><p :class="commonListActive == 1 ? 'active' : null" @click="tabToggle(1)">2 主体证书/资质信息</p></el-badge>
                <el-badge :is-dot="moduleList.includes('empInfo')"><p :class="commonListActive == 2 ? 'active' : null" @click="tabToggle(2)">3 主体人员信息</p></el-badge>
                <el-badge :is-dot="moduleList.includes('financeSocialSecurity')"><p :class="commonListActive == 3 ? 'active' : null" @click="tabToggle(3)">4 主体财税/社保信息</p></el-badge>
                <el-badge :is-dot="moduleList.includes('performance')"><p :class="commonListActive == 4 ? 'active' : null" @click="tabToggle(4)">5 主体业绩信息</p></el-badge>
                <el-badge :is-dot="moduleList.includes('rewardPunishment')"><p :class="commonListActive == 5 ? 'active' : null" @click="tabToggle(5)">6 主体奖惩信息</p></el-badge>
<!--                <el-badge :is-dot="changeModules.includes('serviceItems')"><p :class="commonListActive == 6 ? 'active' : null" @click="tabToggle(6)">7 中介服务事项</p></el-badge>-->
                <el-badge :is-dot="moduleList.includes('otherInfo')"><p :class="commonListActive == 6 ? 'active' : null" @click="tabToggle(6)">7 主体其他信息</p></el-badge>
            </nav>
        </header>
        <header :class="searchBarFixed == true ? 'isFixed' : 'showHeader'">
            <div class="header-left">
                <p>{{informationData.mainName || ""}}</p>
            </div>
            <div class="header-right">
                <el-button class="header-right-more" @click="goChangeList">查看变更内容</el-button>
            </div>
        </header>
        <main>
            <div class="content">
                <mainBasicInfoView v-if="commonListActive == 0" />
                <mainQualifications v-if="commonListActive == 1" />
                <mainMembers v-if="commonListActive == 2" />
                <mainSecurity v-if="commonListActive == 3" />
                <mainAchievement v-if="commonListActive == 4" />
                <mainRewards v-if="commonListActive == 5" />
<!--                <intermediaryServices v-if="commonListActive == 6" />-->
                <otherInformation v-if="commonListActive == 6" />
            </div>
        </main>
    </div>
</template>

<script>
    import mainBasicInfo from './main-basicInfo-form';
    import mainBasicInfoView from './main-basicInfo-view';
    import mainQualifications from './main-qualifications-form';
    import mainMembers from './main-members-form';
    import mainSecurity from './main-security-form';
    import mainAchievement from './main-achievement-form';
    import mainRewards from './main-rewards-form';
    import intermediaryServices from './intermediary-services-form';
    import otherInformation from './main-other-information-form';
    import {mapState} from "vuex";
    import store from '@/store'
    export default {
        name: "index",
        data() {
            return {
                searchBarFixed:false, // 控制吸顶
                id:'',
                viewFlag:false,
                exitFlag:false,
                flag: false,
                tipBoxHeight: '50px',
                commonListActive:0,
                informationData:{},
                commonList: [
                    {
                        name:'1 主体基本信息',
                        module: 'baseInfo',
                    },{
                        name:'2 主体证书/资质信息',
                        module: 'qualificationCert',
                    },{
                        name:'3 主体人员信息',
                        module: 'empInfo',
                    },{
                        name:'4 主体财税/社保信息',
                        module: 'financeSocialSecurity',
                    },{
                        name:'5 主体业绩信息',
                        module: 'performance',
                    }, {
                        name: '6 主体奖惩信息',
                        module: 'rewardPunishment',
                    },
                    // },{
                    //     name:'7 中介服务事项',
                    //     module: 'serviceItems',
                    // },{
                    {
                        name:'7 主体其他信息',
                        module: 'otherInfo',
                    }
                ],
                moduleList:[]
            }
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll)
        },
        created(){
            this.getRouterQuery();
            this.getChangeModul();
            this.getInfo();

        },
        activated() {
            this.getRouterQuery();
            this.getChangeModul();
            this.getInfo();
        },
        components:{
            mainBasicInfo,
            mainBasicInfoView,
            mainQualifications,
            mainMembers,
            mainSecurity,
            mainAchievement,
            mainRewards,
            intermediaryServices,
            otherInformation,
        },
        methods: {
            // 监听滚动距离
            handleScroll () {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop > 190) {
                    this.searchBarFixed = true
                } else {
                    this.searchBarFixed = false
                }
            },
            getRouterQuery(){
                this.id = this.$route.params.changeId;
                this.dataId = this.$route.params.id;
            },
            // 展开提示
            openTips(){
                this.flag = true;
                this.tipBoxHeight = '136px';
            },
            // 闭合提示
            closeTips(){
                this.flag = false;
                this.tipBoxHeight = '50px'
            },
            //切面切换
            tabToggle (index) {
                this.commonListActive = index;
            },
            // 获取页面数据
            getInfo(){
                this.$http.post('/change/hentbaseinfo/get?id='+this.id).then((res) => {
                   if(res.data && res.data.code == 1) {
                     if (res.data.data) {
                       this.informationData = res.data.data;
                       if (res.data.data.state == -1) {
                         this.exitFlag = true;
                         this.viewFlag = false;
                       } else {
                         this.exitFlag = false;
                         this.viewFlag = true;
                       }
                     }
                   }
                })
            },
            // 获取变更的模块
            getChangeModul() {
                this.$http.get('/change/field-record/module-detail?changeRecordId='+this.dataId).then((res) => {
                    let newArr = [];
                    let moduleItemsList = [];
                    if(res.data.code == 1){
                        res.data.data.map((item,index)=>{
                            let arr = {};
                            arr = item.module;
                            newArr[index] = arr;
                            item.moduleItems.forEach((i)=>{
                                moduleItemsList.push(i)
                            })
                        })
                        this.moduleList = newArr;
                        store.commit('common/getModuleItemsList', moduleItemsList)
                    }else{
                        this.$message(res.data.msg)
                        store.commit('common/getModuleItemsList', [])
                    }
                })
            },
            // 提交操作
            submitBasicInfo(){
                this.$http.post('/change/hentbaseinfo/submit?id='+this.id).then(res=>{
                    if(res.data.code == 1){
                        this.$notify({
                            title: '基本信息提交',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    }else{
                        this.$notify({
                            title: '基本信息提交',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })
            },
            // 发起变更操作
            launchChange(){
                this.$http.post('/change/hentbaseinfo/change?entId='+this.id).then((res) => {})
                this.exitFlag = true;
                this.viewFlag = false;
            },
            goChangeList(){
                this.$router.push({path:'/changeHistory-change-list'})
            }
        },
        // 移除监听
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style lang="scss" scoped>
    .router-link-active{
        color: #1890FF !important;
        border-bottom: 2px solid #1890FF;
    }
    .isFixed{
        width: calc(100% - 230px);
        position:fixed;
        z-index:999;
        top: 91px;
        height: 68px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header-left{
            margin-left: 32px;
            p{
                width: 360px;
                height: 22px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
            }
        }
        .header-right{
            margin-right: 24px;
            .header-right-more{
                width: 138px;
                height: 40px;
                background: #1890FF;
                border-radius: 2px;
                color: #FFFFFF;
                cursor:pointer;
                span{
                    font-size: 14px;
                }
            }
        }
    }
    .showHeader{
        display: none;
    }
    .viewHeader{
        height: 190px;
        background: #fff;
        .header-top{
            display: flex;
            justify-content: space-between;
            .header-left{
                margin-left: 32px;
                .header-left-title{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    p{
                        width: 192px;
                        height: 31px;
                        font-size: 24px;
                        font-weight: bold;
                        color: #000000;
                        line-height: 31px;
                        margin-top: 24px;
                    }
                    span{
                        width: 112px;
                        height: 22px;
                        font-size: 14px;
                        color: #1890FF;
                        line-height: 22px;
                        margin-left: 12px;
                        margin-top: 33px;
                        text-align: center;
                        cursor:pointer;
                    }
                }
                .header-left-name{
                    p{
                        width: 360px;
                        height: 22px;
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                        line-height: 22px;
                        margin-top: 24px;
                    }
                }
            }
            .header-right{
                display: flex;
                .header-right-btn{
                    display: flex;
                    flex-direction: column;
                    margin-top: 24px;
                    margin-right: 24px;
                    text-align: right;
                    .header-right-status{
                        margin-bottom: 4px;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.45);
                    }
                    .header-right-examine{
                        width: 140px;
                        height: 28px;
                        font-size: 20px;
                        line-height: 28px;
                        margin-top: 4px;
                    }
                    .header-right-more{
                        width: 138px;
                        height: 40px;
                        background: #1890FF;
                        border-radius: 2px;
                        margin-top: 12px;
                        color: #FFFFFF;
                        cursor:pointer;
                        span{
                            font-size: 14px;
                        }
                    }
                }

            }
        }
        .nav-list{
            margin-top: 30px;
            p{
                display: inline-block;
                font-size: 14px;
                color: #000000;
                line-height: 19px;
                padding-bottom: 11px;
                margin-left: 32px;
                cursor: pointer;
            }
            p.active{
                color: #1890FF;
                border-bottom: 2px solid #1890FF;
                margin-bottom: -2px;
            }
            a:focus, a:hover{
                text-decoration: none;
            }
        }
    }
    .tips{
        background: #FFFBE6;
        position: relative;
        span{
            position: absolute;
            right: 25px;
            top: 13px;
            width: 12px;
            height: 12px;
            line-height: 12px;
            text-align: center;
            color: rgba(0, 0, 0, 0.45);
            cursor: pointer;
        }
        p{
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            margin-left: 45px;
            padding-top: 12px;
            line-height: 28px;
        }
        i{
            width: 18px;
            height: 18px;
            position: absolute;
            left: 24px;
            top: 19px;
        }
    }
    main{
        .content{
            padding: 20px;
        }
    }
</style>